module.exports = __webpack_public_path__ + "static/img/gold5.b2cd98e4.webp";